// extracted by mini-css-extract-plugin
module.exports = {"container":"_-_-pharmacy-src-pages-error-errorPage__container--1MHuT","buttonContainer":"_-_-pharmacy-src-pages-error-errorPage__buttonContainer--25Bct"};